import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Home from './Home';
import { Link } from "react-router-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Header from './Header';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <Header />
    <Routes>
      <Route path="/" element={<Home />} />

    </Routes>

  </BrowserRouter>
);

